import { getShadowAiCategoryLabel } from '@kirin/api-client/contracts/shadow-ai';
import type { BrowserAiToolListItem } from '@kirin/api-client/contracts/shadow-ai-browser-tools';
import type { InstalledToolListItem } from '@kirin/api-client/contracts/shadow-ai-installed-tools';
import type { RunningNowListItem } from '@kirin/api-client/contracts/shadow-ai-running-now';

/**
 * KIR-4855: human names for the bulk-selection checkboxes ("Select <name>").
 * Each must tell the rows on a page apart for screen-reader users.
 */

/** Installed: one row per tool + category, so the category disambiguates. */
export function getInstalledToolRowLabel(row: InstalledToolListItem): string {
  return `${row.name} (${getShadowAiCategoryLabel(row.category)})`;
}

/** Browser: one row per domain + category (KIR-5278), so the category disambiguates. */
export function getBrowserToolRowLabel(row: BrowserAiToolListItem): string {
  return `${row.domain} (${getShadowAiCategoryLabel(row.category)})`;
}

/**
 * Running Now: rows come from every machine in the org and a PID is only
 * unique per machine, so name whose process it is (email → name → machine).
 * `||`, not `??`: an empty email / name (it can reach the DB) falls through
 * too, as in the visible User cell.
 */
export function getRunningNowRowLabel(row: RunningNowListItem): string {
  const owner = row.userEmail || row.userName || row.machineId;
  return `${row.toolName} process ${row.pid} (${owner})`;
}
